import { createFileRoute } from '@tanstack/react-router';
import { StaffingSkillsPage } from '@/pages/staffing/StaffingSkillsPage';

export const Route = createFileRoute('/_authenticated/_app/staffing/skills')({
	component: StaffingSkillsPage,
});
